import react from "react";

function AcademicInfo() {
  return (
    <div className="container">
      <div
        className="row"
        style={{ justifyContent: "normal", textAlign: "justify" }}
      >
        <div>
          <h1 className="fs-2" style={{ color: "#000080" }}>
            IT FutureTech Academics
          </h1>
          <p>
            IT FutureTech Academics are a leading BI Centre of Excellence (CoE)
            who are involved in Business Intelligence Education, Research &
            Development, and Recruitment consulting for building BI specific
            expert teams for meeting global industry requirements. Ubique
            attracts the most analytical minds from the industry, and academia
            to interact with and mentor our students. The faculty groups are
            also engaged in research on the subject of business intelligence and
            publish their ideas in the international IEEE conferences and
            journals.
          </p>
          <p>
            In Industry, IT FutureTech enables enterprises to transform their
            transactional data into information very quickly, thereby building
            an edge over the competitors. Our solutions enable enterprises to
            access the information that they need quickly and efficiently by
            easily connecting all their business processes, and storing all
            their information in a single, integrated repository. IT FutureTech
            helps companies to connect and consolidate fragmented information
            that is residing in different systems across departments to provide
            accurate and real-time data on key metrics of the business.
          </p>
        </div>
        <div className="mt-2">
          <h1 className="fs-5" style={{ color: "#000080" }}>
            Academics Strategic Goals:
          </h1>
          <ul>
            <li>BIG Data Analytics Practice.</li>
            <li>Industry and University Collaboration.</li>
            <li>Product/IP Development.</li>
            <li>Research and Development.</li>
            <li>
              Training Program Organization in association with the
              Universities.
            </li>
            <li>Corporate Training.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default AcademicInfo;
